export default function useDataTransform(props, data) {
  return data?.aggregate?.count
}
